module.exports = __webpack_public_path__ + "img/gallery.5c95ce8e.svg";